import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useToasts } from '@blaze-react/toaster';
import { MdDeleteForever } from 'react-icons/md';
import Input from '@blaze-react/input';
import Button from '@blaze-react/button';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import { DISCOUNTS_WRAPPER_CLASSNAME, PLACHOLDER } from './constants';
import { CONTEXT_KEYS } from '../constants';

const Discounts = ({ placeholderText }) => {
  const [discountCode, setDiscountCode] = useState('');
  const { cartIdKey, cartDataKey } = CONTEXT_KEYS;
  const {
    [cartIdKey]: cartId,
    [cartDataKey]: cartData,
    isCartLoading,
    isBasketEmpty,
    handleAddDiscountToCart,
    handleRemoveDiscountFromCart
  } = useEcommerceContext();
  const { addToast = () => {} } = useToasts();

  if (!cartId || isBasketEmpty) return null;

  const { discounts = [] } = cartData || {};

  const onError = error => {
    addToast(error.message, {
      appearance: 'error',
      autoDismiss: true
    });
  };

  const onClick = () => {
    handleAddDiscountToCart({
      input: {
        code: discountCode
      },
      onError
    });
  };

  const removeDiscount = discountId => {
    handleRemoveDiscountFromCart({
      input: {
        discountId
      },
      onError
    });
  };

  return (
    <div className={DISCOUNTS_WRAPPER_CLASSNAME}>
      <div className={`${DISCOUNTS_WRAPPER_CLASSNAME}__discounts`}>
        {discounts.map(({ id, name, formattedTotalPrice, totalPrice }) => (
          <div key={name} className={`${DISCOUNTS_WRAPPER_CLASSNAME}__discount`}>
            <span>{name}</span>
            <span>{formattedTotalPrice || totalPrice}</span>
            <button type="button" aria-label="remove discount" onClick={() => removeDiscount(id)}>
              <MdDeleteForever />
            </button>
          </div>
        ))}
      </div>
      <div className={`${DISCOUNTS_WRAPPER_CLASSNAME}__input`}>
        <Input
          value={discountCode}
          disabled={isCartLoading}
          id="ecommerce-discounts"
          placeholder={placeholderText || PLACHOLDER}
          onChange={({ value: eValue }) => setDiscountCode(eValue)}
        />
        <Button
          type="submit"
          name="button"
          onClick={onClick}
          disabled={isCartLoading || !discountCode}>
          Apply
        </Button>
      </div>
    </div>
  );
};

Discounts.propTypes = {
  placeholderText: PropTypes.string
};

Discounts.defaultProps = {
  placeholderText: null
};

export default Discounts;
